// eslint-disable-next-line no-unused-vars
export enum NavigationPath {
  HOME = 0,
  PROPERTY_MANAGEMENT = 1,
  OFFER = 2,
  SUCCESSFUL_CASES = 3,
  SETTINGS = 4,
}
